import React, { useEffect } from 'react';
import constants from '../util/constants';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import { connectToLichess } from '../redux/actions/userActions';
const LICHESS_BASE_URL = constants.LICHESS_BASE_URL;

const getToken = async (authCode, verifier, url) => await fetch(`${LICHESS_BASE_URL}/api/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      grant_type: 'authorization_code',
      redirect_uri: url,
      client_id: 'chess-app',
      code: authCode,
      code_verifier: verifier,
    })
  }).then(res => res.json());

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const OauthCallback = (props) => {
  const query = useQuery();
  const code = query.get('code');
  const state = query.get('state');

  useEffect(() => {
    const lichessOauthConfig = JSON.parse(localStorage.getItem('lichessOauthConfig'));
    const { verifier, redirectUrl } = lichessOauthConfig;
    const fetchToken = async () => {
        const token = await getToken(code, verifier, redirectUrl);
        props.connectToLichess(token.access_token);
    };

    fetchToken();
  }, [code]);

  return (
    <div>
      {props.user.lichessConnected ? (
        window.location.href = '/play'
      ) : (
        "Loading..."
      )}
    </div>
  )
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

const mapActionsToProps = {
  connectToLichess
};

export default connect(mapStateToProps, mapActionsToProps)(OauthCallback);